import {
  z,
} from 'zod';

import {
  activityStatementListSchema,
} from '#features/scout/Schema/ActivityStatement.schema';

export const reportSchema = z.object({
  id: z.number().optional(),
  start: z.coerce.string().transform(str => new Date(str)),
  end: z.coerce.string().transform(str => new Date(str)),
  // document_types: z.string().array().optional(),
  clients: z.object({
    id: z.number().optional(),
    companyName: z.string(),
    ABN: z.string().length(11),
    ssid: z.string().length(10),
  }).array().optional(),
  incomeTaxAccount: z.object({
    tables: z.unknown().array(),
    client_name: z.string(),
    abn: z.string().length(11),
  }).array(),
  integratedClientAccount: z.object({
    tables: z.unknown().array(),
    client_name: z.string(),
    abn: z.string().length(11),
  }).array(),
  activityStatement: activityStatementListSchema,
  generalInterests: z.object({
    tables: z.unknown().array(),
    abn: z.string().length(11),
  }).array(),
  reports: z.object({
    code: z.string(),
    title: z.string(),
  }).array(),
  codes: z.object({
    code: z.string(),
    description: z.string(),
  }).array(),
});

export type Report = z.infer<typeof reportSchema>;
export const reportWithIdSchema = reportSchema.required({
  id: true,
});
export type ReportWithId = z.infer<typeof reportWithIdSchema>;
export const reportsApiResponseSchema = reportWithIdSchema.array();
export type ReportsApiResponse = z.infer<typeof reportsApiResponseSchema>;
